import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setProdotti,
  addProdotto,
  addProdottoId,
  updateProdotto,
  deleteProdotto,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  enumRequestFailure,
  enumRequestStart,
  enumRequestSuccess,
  setTipologia,
  setTipo,
  setAnnoDiProduzione,
  setDenominazione,
  setSelectedProdottoId
} from "./prodottiSlice";
import prodottoAPI from "../../services/prodottoAPI";
import { toast } from "react-toastify";
import { fetchGiacenze } from "../giacenze/giacenzeThunk";

// Fetch all prodotti
export const fetchProdotti = createAsyncThunk(
  "prodottoData/fetchProdotti",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await prodottoAPI.getAllProdotto();
      dispatch(setProdotti(response.data.data));
      // console.log(response.data.data, 'data of fetch');

      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch prodotti.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const singleProdotti = createAsyncThunk(
  "prodotti/fetchSingleProdotti",
  async (prodottoId, {dispatch}) => {
    dispatch(apiRequestStart());
    try {
      const response = await prodottoAPI.getSingleProdoto(prodottoId);
      // localStorage.setItem('prodoti_id',prodottoId)
      dispatch(setSelectedProdottoId(prodottoId));

      // Make sure we're storing the data properly in state
      dispatch(addProdottoId([response.data.data]));
      dispatch(fetchGiacenze(prodottoId))
      // Add logging to debug
      // console.log("Single Prodotto data:", response.data.data);
      
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch single prodotto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
)

// Create new prodotto
export const createProdotto = createAsyncThunk(
  "prodottoData/createProdotto",
  async (payload, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await prodottoAPI.createProdotto(payload);
      dispatch(addProdotto(response.data.data));
      toast.success(response?.data?.message)      
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create prodotto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Update prodotto
export const updateProdottoData = createAsyncThunk(
  "prodottoData/updateProdotto",
  async ({ id, data }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await prodottoAPI.updateProdotto(id, data);
      dispatch(updateProdotto(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update prodotto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Delete prodotto
export const deleteProdottoData = createAsyncThunk(
  "prodottoData/deleteProdotto",
  async (id, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
     const response =  await prodottoAPI.deleteProdotto(id);
      dispatch(deleteProdotto(id));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return id;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete prodotto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fix fetchTipologia to dispatch setTipologia instead of selectTipologia
export const fetchTipologia = createAsyncThunk(
  "prodottoData/fetchTipologia",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart("tipologia"));
    try {
      const response = await prodottoAPI.getTipologia();
      console.log("Tipologia API Response:", response.data.data);
      dispatch(setTipologia(response.data.data)); // Use setTipologia action instead of selectTipologia
      dispatch(enumRequestSuccess("tipologia"));
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch tipologia.";
      dispatch(
        enumRequestFailure({
          enumType: "tipologia",
          error: errorMessage,
        })
      );
      throw new Error(errorMessage);
    }
  }
);

// Add other enum fetching thunks for completeness
export const fetchAnnoDiProduzione = createAsyncThunk(
  "prodottoData/fetchAnnoDiProduzione",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart("annoDiProduzione"));
    try {
      const response = await prodottoAPI.getAnnoDiProduzione();
      dispatch(setAnnoDiProduzione(response.data.data));
      dispatch(enumRequestSuccess("annoDiProduzione"));
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch annoDiProduzione.";
      dispatch(
        enumRequestFailure({
          enumType: "annoDiProduzione",
          error: errorMessage,
        })
      );
      throw new Error(errorMessage);
    }
  }
);

export const fetchTipo = createAsyncThunk(
  "prodottoData/fetchTipo",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart("tipo"));
    try {
      const response = await prodottoAPI.getTipo();
      dispatch(setTipo(response.data.data));
      dispatch(enumRequestSuccess("tipo"));
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch tipo.";
      dispatch(
        enumRequestFailure({
          enumType: "tipo",
          error: errorMessage,
        })
      );
      throw new Error(errorMessage);
    }
  }
);

export const fetchDenominazione = createAsyncThunk(
  "prodottoData/fetchDenominazione",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart("denominazione"));
    try {
      const response = await prodottoAPI.getDenominazione();
      dispatch(setDenominazione(response.data.data));
      dispatch(enumRequestSuccess("denominazione"));
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch denominazione.";
      dispatch(
        enumRequestFailure({
          enumType: "denominazione",
          error: errorMessage,
        })
      );
      throw new Error(errorMessage);
    }
  } )